var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"header":"pdfjs"}},[_c('div',{staticClass:"frame-con"},[_c('pdf',{attrs:{"src":"https://mozilla.github.io/pdf.js/es5/web/compressed.tracemonkey-pldi-09.pdf"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }